import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Competition} from '../../model/competition/Competition';
import {TenantService} from '../../service/tenant.service';
import {User} from '../../model/auth/User';
import {NotificationHandler} from '../../helper/notification.handler';
import {CompetitionService} from '../../service/competition.service';
import {Session} from '../../model/auth/Session';
import {AuthService} from '../../service/auth.service';
import {UrlHelper} from '../../helper/url.helper';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  supportEmail: string;
  supportEmailLabel: string;

  tenant?: Competition | null;
  hosts?: User[];
  session?: Session | null;

  inProgress = false;

  constructor(private tenantService: TenantService,
              private authService: AuthService,
              private competitionService: CompetitionService) {
    this.supportEmailLabel = environment.contacts.supportEmail;
    this.supportEmail = 'mailto:' + this.supportEmailLabel;
  }

  async ngOnInit(): Promise<void> {
    this.tenant = this.tenantService.getTenant();
    this.session = await this.authService.getSession();

    this.loadHostInfo();
  }

  get signInUrl() {
    return UrlHelper.SIGN_IN_PATH;
  }

  loadHostInfo() {
    this.inProgress = true;

    if (this.showHostSupport) {
      this.competitionService.getContactHosts(this.tenant?.id as string).subscribe(hosts => {
        if (hosts && hosts.length > 0) {
          this.hosts = hosts || [];
        }
      }, error => {
        NotificationHandler.handleError($localize`:Notifications|Competition hosts fetch has failed message@@notifications-competition-hosts-fetch-failed-error:Competition hosts fetch has failed`, error);
      }, () => {
        this.inProgress = false;
      });
    } else {
      this.inProgress = false;
    }
  }

  get showHostSupport(): boolean {
    return !!this.tenant?.id
      && ((this.session && !this.session.isHost() && !this.session.isAdmin()) || this.showSignIn);
  }

  get showSignIn(): boolean {
    return !this.session || !this.session.isValid();
  }
}
